//libs
import { useCallback } from 'react';

import { ArrowIosDownward } from '@lyearn/icons';

//components
import {
  Accordion as AccordionDefaultComponent,
  AccordionDetails,
  AccordionSummary,
} from '../../baseComponents';
//types
import { AccordionRendererProps } from '../../types';

const AccordionRenderer: React.FC<AccordionRendererProps> = (props) => {
  const {
    Accordion,
    SectionRenderer,
    BodyRenderer,
    ItemRenderer,
    accordionProps,
    rendererProps,
    onAccordionChange,
    section,
    index,
  } = props;

  const onAccordionChangeHandler = useCallback(
    (expanded: boolean) => onAccordionChange?.(expanded, index),
    [index, onAccordionChange],
  );

  const AccordionComponent = Accordion ?? AccordionDefaultComponent;

  const Items = section.items?.map((item, itemIndex) =>
    ItemRenderer({
      key: item.id,
      sectionIndex: index,
      itemIndex,
      item,
      ...rendererProps?.itemRendererProps,
    }),
  );

  const AccordionComponentChildren = [
    <AccordionSummary
      key="accordion-summary"
      expandIcon={<ArrowIosDownward className="h-24 w-24 fill-current text-text-primary" />}
      {...accordionProps?.accordionSummary}>
      {SectionRenderer({ sectionIndex: index, section, ...rendererProps?.sectionRendererProps })}
    </AccordionSummary>,
    <AccordionDetails key="accordion-details" {...accordionProps?.accordionDetails}>
      {BodyRenderer({
        sectionIndex: index,
        section,
        ...rendererProps?.bodyRendererProps,
        children: Items,
      })}
    </AccordionDetails>,
  ];

  return AccordionComponent({
    section,
    sectionIndex: index,
    onChange: onAccordionChangeHandler,
    ...accordionProps?.accordion,
    children: AccordionComponentChildren,
  });
};

export default AccordionRenderer;
